import { styled } from '@mui/material/styles';
import { Box, TextField, List, ListItem, ListItemText } from '@mui/material';

export const MapContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  minHeight: '500px',
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  border: `1px solid ${theme.custom.stroke}`,
  position: 'relative',

  '& .mapboxgl-canvas': {
    outline: 'none',
  },

  '& .mapboxgl-control-container': {
    '& .mapboxgl-ctrl-group': {
      background: theme.custom.background1,
      border: `1px solid ${theme.custom.stroke}`,
      borderRadius: theme.shape.borderRadius,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },

    '& button': {
      color: theme.custom.text,
      '&:hover': {
        backgroundColor: theme.custom.background2,
      },
    },
  },
}));

export const MapPin = styled('div')(({ theme }) => ({
  background: theme.custom.primary,
  width: 24,
  height: 24,
  borderRadius: '50%',
  color: theme.custom.textCTA,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
  transform: 'translate(-50%, -50%)',
  fontSize: '12px',
  fontWeight: 'bold',
  border: `2px solid ${theme.custom.background1}`,

  '&:hover': {
    background: theme.custom.primaryDark,
    transform: 'translate(-50%, -50%) scale(1.1)',
    transition: 'all 0.2s ease-in-out',
  },
}));

export const MapControls = styled(Box)(() => ({
  position: 'absolute',
  top: 16,
  left: 16,
  zIndex: 1000,
  display: 'flex',
  gap: 8,
  flexDirection: 'column',
}));

export const AreaListContainer = styled(Box)(({ theme }) => ({
  width: 320,
  height: '100%',
  backgroundColor: theme.custom.background1,
  border: `1px solid ${theme.custom.stroke}`,
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

export const AreaListHeader = styled(Box)(({ theme }) => ({
  padding: '16px',
  borderBottom: `1px solid ${theme.custom.stroke}`,
  backgroundColor: theme.custom.background2,
}));

export const AreaSearchField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.custom.background1,
    color: theme.custom.text,
    borderRadius: '20px',
    '& fieldset': {
      borderColor: theme.custom.stroke,
      borderRadius: '20px',
    },
    '&:hover fieldset': {
      borderColor: theme.custom.primary,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.custom.primary,
    },
    '& input': {
      color: theme.custom.text,
      '&::placeholder': {
        color: theme.custom.textLight,
        opacity: 1,
      },
    },
    '& .MuiInputAdornment-root': {
      color: theme.custom.textLight,
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.custom.textLight,
    '&.Mui-focused': {
      color: theme.custom.primary,
    },
  },
}));

export const AreaList = styled(List)(({ theme }) => ({
  flex: 1,
  overflow: 'auto',
  padding: 0,
  '& .MuiListItem-root': {
    borderBottom: `1px solid ${theme.custom.stroke}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
}));

export const AreaListItemContainer = styled(ListItem)(({ theme }) => ({
  cursor: 'pointer',
  padding: '12px 16px',
  '&:hover': {
    backgroundColor: theme.custom.background2,
  },
  '&.selected': {
    backgroundColor: theme.custom.primaryLight,
    borderLeft: `4px solid ${theme.custom.primary}`,
  },
}));

export const AreaListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-primary': {
    color: theme.custom.text,
    fontWeight: 500,
    fontSize: '14px',
  },
  '& .MuiListItemText-secondary': {
    color: theme.custom.textLight,
    fontSize: '12px',
  },
}));

export const MapWithSidebarContainer = styled(Box)(() => ({
  display: 'flex',
  height: '100%',
  gap: 16,
}));

export const MapContentContainer = styled(Box)(() => ({
  flex: 1,
  minHeight: '600px',
}));
